import { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import ApiService from '../../../../services/api';
import '../../css/editor.css';
import '../../css/teacher_list.css';
import Save from '../../../../media/save.png';
import Delete from '../../../../media/delete.png';
import { confirmToast } from '../../../app/components/confirmToast';
import Category from '../../../../media/category.png';
import Back from '../../../../media/back.png';


const EditCategory = () => {
  const {slug} = useParams();
  
  const location = useLocation();
  const categoryName = location.state?.categoryName;
  const [name, setName] = useState('');
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const res = await ApiService.getCategory(slug);
        setName(res.name); 
      } catch (err) {
        console.error('Errore nel recupero categoria:', err);
        toast.error('Errore nel caricamento della categoria');
        navigate('/admin/categorie');
      }
    };

    if (slug) fetchCategory();
  }, [slug, navigate]);

  const handleChange = (e) => {
    setName(e.target.value);
  };

  const validate = () => {
    const errs = {};
    if (!name.trim()) errs.name = ["Inserisci nome categoria" , true];
    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    try {
      setSaving(true);
      await ApiService.updateCategory(slug,{name});
      toast.success('Categoria aggiornata con successo!');
      navigate('/admin/categorie');
    } catch (err) {
      console.error(err);
      toast.error('Errore durante l\'aggiornamento');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    confirmToast({
            message: `Sei sicuro di voler eliminare questa categoria?`,
            type: "error",
            confirmText: "Elimina",
             onConfirm: async () => {
              try {
                setDeleting(true);
                await ApiService.deleteCategory(slug);
                toast.success(`Categoria eliminata con successo`);
                navigate('/admin/categorie');
              } catch (err) {
                toast.error("Errore durante l'eliminazione");      
              }
                finally {
                  setDeleting(false);
                }
            },
          });
  };

  return (
    <form className="editor-form" onSubmit={handleSubmit}>
      <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2><img src={Category} alt="" className="section-image" />Modifica Categoria</h2>
        <button
          type="button"
          onClick={handleDelete}
          disabled={saving || deleting}
          style={{ backgroundColor: 'crimson'}}
        >
          <img src={Delete} alt="Elimina" className="button-image2" />
          {deleting ? 'Eliminazione in corso...' : 'Elimina'}
        </button>
      </div>

       <button
        className="tab-button"
        style={{marginTop:'20px'}}
        onClick={() => navigate(`/admin/categorie`)}
        type='button'
      >
        <img src={Back} alt="Modifica" className="button-image" style={{marginTop:'-2.5px', marginRight:'2.5px'}}/>
        Torna all'elenco delle categorie
      </button>

      <label>Nome categoria *</label>
      <input
        type="text"
        name="name"
        value={name}
        onChange={handleChange}
        className={`input ${errors.name ? "error" : ""}`}
      />
      {errors.name && <span className='error'>{errors.name}</span>}
      </div>

      <button type="submit" disabled={saving || deleting} style={{ backgroundColor: '#2ecc71', marginTop: "50px" }}>
        <img src={Save} alt="Salva" className="button-image2" />
        {saving ? 'Salvataggio in corso...' : 'Salva'}
      </button>
    </form>
  );
};

export default EditCategory;
